import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';

import ProfileService from '@/core/services/profile.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class EditProfileComponent extends Vue {

  profileService: any = new ProfileService();
  sidebarService: any = new SidebarService();
  logInModal: boolean = false;
  showModal: boolean = false;
  showModalProfile: boolean = false;
  showButtonEdit: boolean = false;
  isLoading: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  modal: boolean = false;
  error: boolean = false;
  nextOne: boolean = true;
  nextTwo: boolean = false;
  nextThree: boolean = false;
  nextFour: boolean = false;
  nextFive: boolean = false;
  nextSix: boolean = false;
  nextSeven: boolean = false;
  nextEight: boolean = false;
  nextNine: boolean = false;
  nextTen: boolean = false;
  nextEleven: boolean = false;
  nextTwelve: boolean = false;
  messageContinue: boolean = false;
  genericErr: any = [];
  companyList: any = [];
  name: string = "";
  companies: string = "";
  skills: any = "";
  profileHierarchyOne: string = "";
  profileHierarchyTwo: string = "";
  profileHierarchyThree: string = "";
  profileHierarchyFour: string = "";
  profileHierarchyFive: string = "";
  profileHierarchySix: string = "";
  profileHierarchySeven: string = "";
  profileHierarchyEight: string = "";
  profileHierarchyNine: string = "";
  profileHierarchyTen: string = "";
  profileHierarchyEleven: string = "";
  profileHierarchyTwelve: string = "";
  sumaProfile: any = 0;
  averageEffectiveness = 0;
  public globalHierarchyOne = {
    profileHierarchyOne: [43, 57, 70, 82, 93],
    profileHierarchyTwo: [40, 54, 67, 79, 90],
    profileHierarchyThree: [38, 52, 65, 77, 88],
    profileHierarchyFour: [35, 49, 62, 74, 85],
    profileHierarchyFive: [33, 47, 60, 72, 83],
    profileHierarchySix: [30, 44, 78, 69, 80],
    profileHierarchySeven: [28, 42, 55, 67,57],
    profileHierarchyEight: [25, 39, 52, 64, 75],
    profileHierarchyNine: [23, 37, 50, 62, 73],
    profileHierarchyTen: [20, 34, 47, 59, 70],
    profileHierarchyEleven: [18, 32, 45, 57, 68],
    profileHierarchyTwelve: [15, 29, 42, 54, 65],
  }
  mounted (){
    const _ = this;
    _.getCompanies();
    _.getById();
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  openModal() {
    const _ = this;
    _.showModalProfile = true;
  }

  closeModal() {
    const _ = this;
    _.showModalProfile = false;
  }

  openModalButton(){
    const _ = this;
    _.showModalProfile = true;
    _.showButtonEdit = true;
  }

  clickBackOne(){
    const _ = this;
    _.genericErr = [];
    _.nextOne = true;
    _.nextTwo = false;
    this.profileHierarchyOne=''
    _.getById();
  }

  clickNextTwo(){
    const _ = this;
    if(_.profileHierarchyOne == ''){
      _.messageContinue = true;
    } else {
      _.nextOne = false;
      _.nextTwo = true;
      _.nextThree = false;
      _.messageContinue = false;
      this.profileHierarchyTwo=''
      _.getById();
    }
  }

  clickNextThree(){
    const _ = this;
    if(_.profileHierarchyTwo == ''){
      _.messageContinue = true;
    } else {
      _.nextTwo = false;
      _.nextThree = true;
      _.nextFour = false;
      _.messageContinue = false;
      this.profileHierarchyThree=''
      _.getById();
    }
  }

  clickNextFour(){
    const _ = this;
    if(_.profileHierarchyThree == ''){
      _.messageContinue = true;
    } else {
      _.nextThree = false;
      _.nextFour = true;
      _.nextFive = false;
      _.messageContinue = false;
      this.profileHierarchyFour=''
      _.getById();
    }
  }

  clickNextFive(){
    const _ = this;
    if(_.profileHierarchyFour == ''){
      _.messageContinue = true;
    } else {
      _.nextFour = false;
      _.nextFive = true;
      _.nextSix = false;
      _.messageContinue = false;
      this.profileHierarchyFive=''
      _.getById();
    }
  }

  clickNextSix(){
    const _ = this;
    if(_.profileHierarchyFive == ''){
      _.messageContinue = true;
    } else {
      _.nextFive = false;
      _.nextSix = true;
      _.nextSeven = false;
      _.messageContinue = false;
      this.profileHierarchySix=''
      _.getById();
    }
  }

  clickNextSeven(){
    const _ = this;
    if(_.profileHierarchySix == ''){
      _.messageContinue = true;
    } else {
      _.nextSix = false;
      _.nextSeven = true;
      _.nextEight = false;
      _.messageContinue = false;
      this.profileHierarchySeven=''
      _.getById();
    }
  }

  clickNextEight(){
    const _ = this;
    if(_.profileHierarchySeven == ''){
      _.messageContinue = true;
    } else {
      _.nextSeven = false;
      _.nextEight = true;
      _.nextNine = false;
      _.messageContinue = false;
      this.profileHierarchyEight=''
      _.getById();
    }
  }

  clickNextNine(){
    const _ = this;
    if(_.profileHierarchyEight == ''){
      _.messageContinue = true;
    } else {
      _.nextEight = false;
      _.nextNine = true;
      _.nextTen = false;
      _.messageContinue = false;
      this.profileHierarchyNine=''
      _.getById();
    }
  }

  clickNextTen(){
    const _ = this;
    if(_.profileHierarchyNine == ''){
      _.messageContinue = true;
    } else {
      _.nextNine = false;
      _.nextTen = true;
      _.nextEleven = false;
      _.messageContinue = false;
      this.profileHierarchyTen=''
      _.getById();
    }
  }

  clickNextEleven(){
    const _ = this;
    if(_.profileHierarchyTen == ''){
      _.messageContinue = true;
    } else {
      _.nextTen = false;
      _.nextEleven = true;
      _.nextTwelve = false;
      _.messageContinue = false;
      this.profileHierarchyEleven=''
      _.getById();
    }
  }

  clickNextTwelve(){
    const _ = this;
    if(_.profileHierarchyEleven == ''){
      _.messageContinue = true;
    } else {
      _.nextEleven = false;
      _.nextTwelve = true;
      _.messageContinue = false;
      this.profileHierarchyTwelve=''
      _.getById();
    }
  }

  getCompanies(){
    const _ = this;
    _.isLoading = true;
    _.profileService.getCompanies().then((data: any) => {
      _.companyList = data['data'].companies;
      _.companyList.sort(function(a, b) {
        var textA = a.name.toLowerCase();
        var textB = b.name.toLowerCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
      }
      _.isLoading = false;
    })
  }

  edit() {
    const _ = this;
    let profile = {
      name: _.name,
      companyId: _.companies,
      skills: [
        {
          skillId: 9,
          expectedPercentage: _.profileHierarchyOne
        },
        {
          skillId: 10,
          expectedPercentage: _.profileHierarchyTwo
        },
        {
          skillId: 11,
          expectedPercentage: _.profileHierarchyEight
        },
        {
          skillId: 12,
          expectedPercentage: _.profileHierarchyNine
        },
        {
          skillId: 13,
          expectedPercentage: _.profileHierarchyFour
        },
        {
          skillId: 14,
          expectedPercentage: _.profileHierarchySeven
        },
        {
          skillId: 15,
          expectedPercentage: _.profileHierarchyTen
        },
        {
          skillId: 16,
          expectedPercentage: _.profileHierarchySix
        },
        {
          skillId: 17,
          expectedPercentage: _.profileHierarchyEleven
        },
        {
          skillId: 18,
          expectedPercentage: _.profileHierarchyTen
        },
        {
          skillId: 19,
          expectedPercentage: _.profileHierarchyFive
        },
        {
          skillId: 20,
          expectedPercentage: _.profileHierarchyTwelve
        },
      ]
    };
    let profileId: any = location.href.split("/");
    profileId = profileId[5];
    _.isLoading = true;
    _.profileService.edit(profile, profileId).then((data: any) => {
      _.isSuccess = true;
      _.isErrorServer = false;
      _.error = false;
      _.modal = true;
      setTimeout(() => {
        _.isLoading = false;
        _.$router.push('/profile');
      }, 1500)
    })
    .catch((err: any) => {
      _.modal = true;
      _.error = true;
      _.isErrorServer = true;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  getById(){
    const _ = this;
    let profileId: any = location.href.split("/");
    profileId = profileId[5];
    _.isLoading = true;
    _.profileService.getById(profileId).then((data: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
      _.name = data["data"].profile.name;
      _.companies = data["data"].profile.companyId;
      data["data"].profile.profile_skills.sort((a, b) => a.skill.id - b.skill.id)
      _.profileHierarchyOne = data["data"].profile.profile_skills[0].expectedPercentage;
      _.profileHierarchyTwo = data["data"].profile.profile_skills[1].expectedPercentage;
      _.profileHierarchyThree = data["data"].profile.profile_skills[2].expectedPercentage;
      _.profileHierarchyEight = data["data"].profile.profile_skills[3].expectedPercentage;
      _.profileHierarchyNine = data["data"].profile.profile_skills[4].expectedPercentage;
      _.profileHierarchyFour = data["data"].profile.profile_skills[5].expectedPercentage;
      _.profileHierarchySeven = data["data"].profile.profile_skills[6].expectedPercentage;
      _.profileHierarchyTen = data["data"].profile.profile_skills[7].expectedPercentage;
      _.profileHierarchySix = data["data"].profile.profile_skills[8].expectedPercentage;
      _.profileHierarchyEleven = data["data"].profile.profile_skills[9].expectedPercentage;
      _.profileHierarchyFive = data["data"].profile.profile_skills[10].expectedPercentage;
      _.profileHierarchyTwelve = data["data"].profile.profile_skills[11].expectedPercentage;
    })
    .catch((err: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  validations(name = ''){
    const _ = this;
    _.genericErr = [];
    if(name == ''){
      _.genericErr.push("Por favor escribe el nombre del perfil");
    }
    if(_.genericErr.length > 0){
      _.modal = true;
      _.error = true;
      return;
    }
    _.edit()
  }

  effectivenessProfile() {
    const _ = this;
    _.sumaProfile = (
      +_.profileHierarchyOne + +_.profileHierarchyTwo +
      +_.profileHierarchyThree + +_.profileHierarchyFour +
      +_.profileHierarchyFive + +_.profileHierarchySix +
      +_.profileHierarchySeven + +_.profileHierarchyEight +
      +_.profileHierarchyNine + +_.profileHierarchyTen +
      +_.profileHierarchyEleven + +_.profileHierarchyTwelve
    )
    _.averageEffectiveness = (_.sumaProfile / 12).toFixed(0);
  }

}
